<template>
  <div class="home" v-if="show" ref="home">
    <!-- <div class="home-info"> -->
    <div class="home-content">
      <div class="top">
        <img class="logo" :src="brandUrl" alt="" />
        <div class="fanyi" @click="$emit('chooseLanguage')">
          <img src="@/assets/img/fanyi.png" alt="" />
          <span>{{ languageType }}</span>
        </div>
      </div>
      <div class="hotel-name">
        <span class="text word-break">{{ hotelName }}</span>
      </div>

      <!-- meeting -->
      <div class="middle-box">
        <div class="left-padding"></div>
        <div class="content-meeting" v-if="type == 'nonguest'">
          <!-- </div> -->
          <div class="room-requests">
            <div
              class="title"
              :class="{ right_content_title: language == 'ar' }"
            >
              <span class="text word-break">{{
                stringList.meeting_room_request
              }}</span>
            </div>
            <div
              class="info"
              v-if="language == 'es'"
              style="display: flex; margin-top: -6px"
              :class="{ no_other: meetingMenuShow.length == 0 }"
            >
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.AV_Assistance,
                    'AV Assistance'
                  )
                "
              >
                <img src="@/assets/img/avassistance.png" alt="" />
                <div>{{ stringList.AV_Assistance }}</div>
              </div>
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.Beverage,
                    'Beverage/Coffee Refill'
                  )
                "
              >
                <img src="@/assets/img/beverage.png" alt="" />
                <div>{{ stringList.Beverage }}</div>
              </div>
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.Breaktime,
                    'Breaktime/Mealtime Change'
                  )
                "
              >
                <img src="@/assets/img/breaktime.png" alt="" />
                <div class="fontPadding">{{ stringList.Breaktime }}</div>
              </div>
              <div
                class="info-item"
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.Request_Hotel_Staff,
                    'Request Hotel Staff'
                  )
                "
              >
                <img src="@/assets/img/requeststaff.png" alt="" />
                <div>{{ stringList.Request_Hotel_Staff }}</div>
              </div>
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.Temperature_Control,
                    'Temperature Control'
                  )
                "
              >
                <img src="@/assets/img/tempcontrol.png" alt="" />
                <div>{{ stringList.Temperature_Control }}</div>
              </div>
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.Miscellaneous,
                    'Other/Miscellaneous'
                  )
                "
              >
                <img src="@/assets/img/othermiscell.png" alt="" />
                <div>{{ stringList.Miscellaneous }}</div>
              </div>
            </div>
            <div
              class="info"
              v-if="language == 'tl'"
              style="display: flex; margin-top: -6px"
              :class="{ no_other: meetingMenuShow.length == 0 }"
            >
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.AV_Assistance,
                    'AV Assistance'
                  )
                "
              >
                <img src="@/assets/img/avassistance.png" alt="" />
                <div>{{ stringList.AV_Assistance }}</div>
              </div>
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.Beverage,
                    'Beverage/Coffee Refill'
                  )
                "
              >
                <img src="@/assets/img/beverage.png" alt="" />
                <div>{{ stringList.Beverage }}</div>
              </div>
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.Breaktime,
                    'Breaktime/Mealtime Change'
                  )
                "
              >
                <img src="@/assets/img/breaktime.png" alt="" />
                <div>{{ stringList.Breaktime }}</div>
              </div>
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.Request_Hotel_Staff,
                    'Request Hotel Staff'
                  )
                "
              >
                <img src="@/assets/img/requeststaff.png" alt="" />
                <div>{{ stringList.Request_Hotel_Staff }}</div>
              </div>
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.Temperature_Control,
                    'Temperature Control'
                  )
                "
              >
                <img src="@/assets/img/tempcontrol.png" alt="" />
                <div>{{ stringList.Temperature_Control }}</div>
              </div>
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.Miscellaneous,
                    'Other/Miscellaneous'
                  )
                "
              >
                <img src="@/assets/img/othermiscell.png" alt="" />
                <div>{{ stringList.Miscellaneous }}</div>
              </div>
            </div>
            <div
              class="info"
              v-if="language == 'de'"
              style="display: flex; margin-top: -6px"
              :class="{ no_other: meetingMenuShow.length == 0 }"
            >
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.AV_Assistance,
                    'AV Assistance'
                  )
                "
              >
                <img src="@/assets/img/avassistance.png" alt="" />
                <div>{{ stringList.AV_Assistance }}</div>
              </div>
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.Beverage,
                    'Beverage/Coffee Refill'
                  )
                "
              >
                <img src="@/assets/img/beverage.png" alt="" />
                <div>{{ stringList.Beverage }}</div>
              </div>
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.Breaktime,
                    'Breaktime/Mealtime Change'
                  )
                "
              >
                <img src="@/assets/img/breaktime.png" alt="" />
                <div>{{ stringList.Breaktime }}</div>
              </div>
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.Request_Hotel_Staff,
                    'Request Hotel Staff'
                  )
                "
              >
                <img src="@/assets/img/requeststaff.png" alt="" />
                <div>{{ stringList.Request_Hotel_Staff }}</div>
              </div>
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.Temperature_Control,
                    'Temperature Control'
                  )
                "
              >
                <img src="@/assets/img/tempcontrol.png" alt="" />
                <div class="fontPadding">
                  {{ stringList.Temperature_Control }}
                </div>
              </div>
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.Miscellaneous,
                    'Other/Miscellaneous'
                  )
                "
              >
                <img src="@/assets/img/othermiscell.png" alt="" />
                <div>{{ stringList.Miscellaneous }}</div>
              </div>
            </div>
            <div
              class="info"
              v-if="language == 'en'"
              style="display: flex; margin-top: -6px"
              :class="{ no_other: meetingMenuShow.length == 0 }"
            >
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.AV_Assistance,
                    'AV Assistance'
                  )
                "
              >
                <img src="@/assets/img/avassistance.png" alt="" />
                <div>{{ stringList.AV_Assistance }}</div>
              </div>
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.Beverage,
                    'Beverage/Coffee Refill'
                  )
                "
              >
                <img src="@/assets/img/beverage.png" alt="" />
                <!-- <span>{{ stringList.Beverage }}</span> -->
                <div class="info-item-text">{{ stringList.Beverage }}</div>
              </div>
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.Breaktime,
                    'Breaktime/Mealtime Change'
                  )
                "
              >
                <img src="@/assets/img/breaktime.png" alt="" />
                <div class="fontPadding">{{ stringList.Breaktime }}</div>
              </div>
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.Request_Hotel_Staff,
                    'Request Hotel Staff'
                  )
                "
              >
                <img src="@/assets/img/requeststaff.png" alt="" />
                <div>{{ stringList.Request_Hotel_Staff }}</div>
              </div>
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.Temperature_Control,
                    'Temperature Control'
                  )
                "
              >
                <img src="@/assets/img/tempcontrol.png" alt="" />
                <div>{{ stringList.Temperature_Control }}</div>
              </div>
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.Miscellaneous,
                    'Other/Miscellaneous'
                  )
                "
              >
                <img src="@/assets/img/othermiscell.png" alt="" />
                <div>{{ stringList.Miscellaneous }}</div>
              </div>
            </div>
            <div
              class="info"
              v-if="language == 'ar'"
              style="display: flex; margin-top: -6px"
              :class="{ no_other: meetingMenuShow.length == 0 }"
            >
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.AV_Assistance,
                    'AV Assistance'
                  )
                "
              >
                <img src="@/assets/img/avassistance.png" alt="" />
                <div>{{ stringList.AV_Assistance }}</div>
              </div>
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.Beverage,
                    'Beverage/Coffee Refill'
                  )
                "
              >
                <img src="@/assets/img/beverage.png" alt="" />
                <div>{{ stringList.Beverage }}</div>
              </div>
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.Breaktime,
                    'Breaktime/Mealtime Change'
                  )
                "
              >
                <img src="@/assets/img/breaktime.png" alt="" />
                <div>{{ stringList.Breaktime }}</div>
              </div>
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.Request_Hotel_Staff,
                    'Request Hotel Staff'
                  )
                "
              >
                <img src="@/assets/img/requeststaff.png" alt="" />
                <div>{{ stringList.Request_Hotel_Staff }}</div>
              </div>
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.Temperature_Control,
                    'Temperature Control'
                  )
                "
              >
                <img src="@/assets/img/tempcontrol.png" alt="" />
                <div class="fontPadding">
                  {{ stringList.Temperature_Control }}
                </div>
              </div>
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.Miscellaneous,
                    'Other/Miscellaneous'
                  )
                "
              >
                <img src="@/assets/img/othermiscell.png" alt="" />
                <div>{{ stringList.Miscellaneous }}</div>
              </div>
            </div>
            <div
              class="info"
              v-if="language == 'zh'"
              style="display: flex; margin-top: -6px"
              :class="{ no_other: meetingMenuShow.length == 0 }"
            >
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.AV_Assistance,
                    'AV Assistance'
                  )
                "
              >
                <img src="@/assets/img/avassistance.png" alt="" />
                <div>{{ stringList.AV_Assistance }}</div>
              </div>
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.Beverage,
                    'Beverage/Coffee Refill'
                  )
                "
              >
                <img src="@/assets/img/beverage.png" alt="" />
                <div>{{ stringList.Beverage }}</div>
              </div>
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.Breaktime,
                    'Breaktime/Mealtime Change'
                  )
                "
              >
                <img src="@/assets/img/breaktime.png" alt="" />
                <div>{{ stringList.Breaktime }}</div>
              </div>
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.Request_Hotel_Staff,
                    'Request Hotel Staff'
                  )
                "
              >
                <img src="@/assets/img/requeststaff.png" alt="" />
                <div>{{ stringList.Request_Hotel_Staff }}</div>
              </div>
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.Temperature_Control,
                    'Temperature Control'
                  )
                "
              >
                <img src="@/assets/img/tempcontrol.png" alt="" />
                <div>{{ stringList.Temperature_Control }}</div>
              </div>
              <div
                class="info-item"
                style=""
                @click="
                  $emit(
                    'gotoMeetingServices',
                    stringList.Miscellaneous,
                    'Other/Miscellaneous'
                  )
                "
              >
                <img src="@/assets/img/othermiscell.png" alt="" />
                <div>{{ stringList.Miscellaneous }}</div>
              </div>
            </div>
          </div>
          <div v-if="meetingMenuShow.length != 0" class="meeting-server-menu">
            <template v-for="(item, index) in meetingMenuShow">
              <div
                :key="item.id"
                @click="$emit('pdfView', item.fileUrl, item.title)"
                class="meeting-box"
              >
                <!-- 分割线 -->
                <div class="meeting-menu-line-out">
                  <div
                    class="meeting-menu-line-box"
                    :hidden="index == 0 ? true : false"
                  >
                    <!-- <div class="meeting-menu-line-circle"></div> -->
                    <div class="meeting-menu-line"></div>
                    <!-- <div class="meeting-menu-line-circle"></div> -->
                  </div>
                </div>
                <!-- 按钮 -->
                <div class="meeting-menu">
                  <img src="@/assets/img/other.png" alt="" />
                  <span
                    :class="{ right_text_item: language == 'ar' }"
                    style="
                      line-height: 18px;
                      word-wrap: break-word;
                      word-break: normal;
                      overflow: hidden;
                    "
                    >{{ item.handleTitle }}</span
                  >
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="right-padding"></div>
      </div>
    </div>

    <div class="foot">
      <span class="text1">
        {{ address }}
      </span>
      <span class="text1">
        {{ phone }}
      </span>
      <span class="text2" style="display: flex; align-items: center">
        <img
          style="width: 9px; margin-right: 5px"
          src="@/assets/logo2.png"
          alt=""
        /><span>{{ stringList.poweredBy }}</span>
      </span>
    </div>

    <van-popup
      class="chose-language"
      v-model="showLanguageChoose"
      closeable
      :close-icon="require('@/assets/img/close.png')"
      position="top"
      :close-on-click-overlay="true"
      :get-container="() => $refs.home"
    >
      <!-- 一级 -->
      <div class="pop">
        <div
          class="pop-title"
          :class="{ right_content_language_title: language == 'ar' }"
        >
          <span class="title">{{ stringList.language_select }}</span>
        </div>
        <div class="pop-container">
          <div
            class="pop-item"
            v-for="item in languageList"
            :key="item.value"
            @click="$emit('changeLanguage', item.value)"
            :class="{ 'pop-item-active': item.value == language }"
          >
            <span class="text" :class="{ active: item.value == language }">{{
              item.type
            }}</span>
            <span class="text2" :class="{ active: item.value == language }">{{
              item.name
            }}</span>
            <span
              class="text3"
              v-if="item.value == language"
              :class="{ active: item.value == language }"
              >√</span
            >
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "",
    },
    brandUrl: {
      type: String,
      default: "",
    },
    hotelName: {
      type: String,
      default: "",
    },
    h5HeaderBg: {
      type: String,
      default: "",
    },
    languageType: {
      type: String,
      default: "en",
    },
    language: {
      type: String,
      default: "en",
    },
    languageList: {
      type: Array,
      default: () => [],
    },
    stringList: {
      default: () => {
        return {};
      },
    },
    meetingMenuShow: {
      type: Array,
      default: () => [],
    },
    address: {
      type: String,
      default: "",
    },
    phone: {
      type: String,
      default: "",
    },
    showLanguageChoose: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.right_content_language_title {
  padding-left: 80px;
}
.right_text_item {
  text-align: right !important;
  display: grid !important;
}
// .title_mini_font {
//   span {
//     font-size: 13px !important;
//   }
// }
// .title_mini_font2 {
//   span {
//     font-size: 12px !important;
//   }
// }
.home {
  text-align: left;
  width: 100%;
  height: 100%;
  .home-content {
    min-height: calc(100% - 68px);
    background-color: #fff;
  }
  // position: relative;
  // height: 100%;
  // .home-info::-webkit-scrollbar {
  //   display: none;
  // }
  // .home-info {
  //   height: calc(100% - 68px);
  //   overflow: auto;
  //   background-color: #ffffff;
  .word-break {
    word-break: normal;
  }
  .top {
    height: 50px;
    padding: 0 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #ffffff;

    .logo {
      // width: 103px;
      height: 35px;
    }

    .fanyi {
      height: 28px;
      padding: 4px 12px;
      border-radius: 16px;
      // border: 1px solid #e8e8e8;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #e8e8e8;
      cursor: pointer;
      img {
        width: 16px;
        height: 16px;
        margin-right: 6px;
      }
      span {
        font-size: 13px;
      }
    }
  }
  .hotel-name {
    min-height: 40px;
    padding: 8px 20px;
    display: flex;
    align-items: center;
    background-color: #ffffff;
    border-top: 1px solid #e8e8e8;
    border-bottom: 1px solid #e8e8e8;
    .text {
      color: $primary-color;
      font-size: 18px;
      font-family: $fontFamily;
      line-height: 20px;
    }
  }

  .middle-box {
    .left-padding {
      flex-grow: 1;
      background-color: #ffffff;
    }

    .right-padding {
      flex-grow: 1;
      background-color: #ffffff;
    }
    display: flex;

    .content-meeting {
      // padding: 12px 36px 0px 36px;
      padding-top: 20px;
      width: 294px;
      background-color: #ffffff;
      // border-bottom: 1px solid #e8e8e8;

      .my-swipe {
        margin-bottom: $home-padding15;
        .van-swipe-item {
          border-radius: 6px;

          .swipe-area {
            position: relative;
            img {
              height: 120px;
              width: 100%;
              border-radius: 12px;
            }
            .mask {
              position: absolute;
              min-height: 24px;
              padding: 3px 10px;
              width: 100%;
              top: 45px;
              display: flex;
              align-items: center;
              justify-content: center;
              background: linear-gradient(
                to right,
                rgba(255, 255, 255, 0.35),
                rgba(255, 255, 255, 0.85) 30%,
                rgba(255, 255, 255, 0.85) 70%,
                rgba(255, 255, 255, 0.35)
              );
              // background: linear-gradient(
              //   to right,
              //   rgba(255, 255, 255, 0.35),
              //   rgba(255, 255, 255, 0.85),
              //   rgba(255, 255, 255, 0.35)
              // );

              .text {
                color: #000000;
                font-size: 22px;
                font-family: $fontFamily;
                line-height: 24px;
              }
            }
          }
        }
      }

      .room-requests {
        // margin-top: $home-padding15;
        // height: 98px;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
        .title {
          // height: 26px;
          min-height: 26px;
          display: flex;
          align-items: center;
          justify-content: center;
          .text {
            line-height: 18px;
            // color: #4f4f4f;
            color: #000;
            font-size: 20px;
            font-family: $fontFamily;
            font-weight: 700;
            text-align: center;
          }
        }

        .no_other {
          margin-bottom: 42px !important;
        }
        .info {
          // height: 60px;
          // display: flex;
          align-items: center;
          flex-wrap: wrap;
          justify-content: space-between;
          margin: 0;
          margin-bottom: 28px;
          .info-item {
            height: 112px;
            width: 128px;
            display: flex;
            flex-flow: column;
            background-color: #f5f4f9;
            align-items: center;
            justify-content: center;
            border-radius: 8px;
            border: 1px solid #9a94c0;
            // padding: 0 18px;
            margin-top: 24px;
            div {
              // height: 25px;
              // color: #4f4f4f;
              color: #000;
              font-size: 14px;
              line-height: 18px;
              font-family: "Arial";
              display: flex;
              align-items: center;
              margin-top: 10px;
              text-align: center;
              white-space: pre-wrap;
              padding: 0 2px;
            }
            .info-item-text {
              color: #000;
              font-size: 14px;
              line-height: 18px;
              font-family: "Arial";
              display: flex;
              align-items: center;
              margin-top: 10px;
              text-align: center;
              white-space: pre-wrap;
              padding: 0 2px;
            }
            img {
              height: 32px;
              width: 32px;
            }
          }
          .info-item:active {
            background: #ebebeb;
          }

          .info-item:hover {
            background: #ebebeb;
          }

          .info-item:last-child {
            margin-right: 0px;
          }
        }
      }

      .dine_drink {
        margin-top: $home-padding15;
        .title {
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 2px solid #e8e8e8;
          margin-bottom: $home-title-margin-bottom10;
          .text {
            line-height: 18px;
            // color: #4f4f4f;
            color: #000;
            font-size: 16px;
            font-family: $fontFamily;
            font-weight: 700;
          }

          .text1 {
            width: 70px;
            text-align: right;
            line-height: 15px;
            // color: #4f4f4f;
            color: #000;
            font-size: 13px;
            font-family: $fontFamily;
          }
        }

        .info::-webkit-scrollbar {
          display: none;
        }

        .info {
          display: flex;
          align-items: start;
          // justify-content: space-between;
          overflow-x: auto;
          overflow-y: hidden;

          .item {
            width: 120px;
            // height: 105px;
            flex-shrink: 0;
            margin-right: 15px;
            border-radius: 5px;

            img {
              height: 65px;
              width: 100%;
              border-radius: 5px;
            }

            .text {
              // height: 40px;
              margin-top: 5px;
              // color: #4f4f4f;
              color: #000;
              font-size: 15px;
              font-family: $fontFamily;
              line-height: 19px;
              display: flex;
              // align-items: center;
              margin-left: 6px;
              // justify-content: center;
            }
          }

          .item:last-child {
            margin-right: 0;
          }
        }

        // .info::-webkit-scrollbar {
        //   display: none; /* Chrome Safari */
        // }
      }

      .hotel_information {
        margin-top: $home-padding15;

        .title {
          height: 30px;
          display: flex;
          align-items: center;
          border-bottom: 2px solid #e8e8e8;
          .text {
            line-height: 18px;
            // color: #4f4f4f;
            color: #000;
            font-size: 16px;
            font-family: $fontFamily;
            font-weight: 700;
          }
        }

        .item {
          height: 50px;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #e8e8e8;
          padding: 0 10px;

          .icon {
            height: 22px;
            margin-right: 30px;
          }

          span {
            flex: 1;
            line-height: 17px;
            // color: #4f4f4f;
            color: #000;
            font-size: 15px;
            font-family: $fontFamily;
          }
        }

        .item:last-child {
          border-bottom: 0px;
        }
      }
      .meeting-server-menu {
        display: flex;
        margin: 0px 0px 42px 0px;
        // padding: 2.5px 0px;
        width: 100%;
        flex-direction: column;
        // background: linear-gradient(135deg, #f9f7f7, #f8fbff);
        background-color: #f5f4f9;
        border: 1px solid #9a94c0;
        border-radius: 8px;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        .meeting-box {
          width: 100%;
        }
        .meeting-menu-line-out {
          width: 100%;
          display: flex;
          justify-content: center;
          align-content: center;

          .meeting-menu-line-box {
            width: 100%;
            align-items: center;
            display: flex;
            flex-direction: row;
          }
        }

        .meeting-menu-line-circle {
          width: 5px;
          height: 5px;
          border-radius: 2.5px;
          background-color: #e8e8e8;
        }
        .meeting-menu-line {
          width: 100%;
          height: 1px;
          background-color: #afafaf;
        }
        .meeting-menu {
          min-height: 35px;
          display: flex;
          flex-direction: row;
          align-items: start;
          padding: 10px 20px;
          font-size: 14px;
          color: #000;
          font-family: "Arial";
          img {
            height: 18px;
            width: 18px;
          }
          span {
            margin-left: 13px;
            width: 220px;
          }
        }
        .meeting-menu:active {
          background: #ebebeb;
        }

        .meeting-menu:hover {
          background: #ebebeb;
        }
      }
    }
  }

  .foot {
    height: 68px;
    display: flex;
    flex-flow: column;
    text-align: center;
    align-items: center;
    justify-content: center;
    background-color: #f8f8f8;
    padding: 10px 20px;
    // position: absolute;
    // bottom: 0;
    // width: 100%;
    // border-top: 1px solid #e8e8e8;

    .text1 {
      font-family: $fontFamily;
      color: #101010;
      font-size: 12px;
      line-height: 14px;
      // width: 298px;
      margin-bottom: 5px;
    }
    .text2 {
      font-family: $fontFamily;
      color: #9a9a9a;
      font-size: 12px;
      line-height: 14px;
      // width: 298px;
    }
  }
}
.right_content_title {
  text-align: right !important;
  display: block !important;
}
.right_content_item {
  text-align: right !important;
}
.pop {
  word-break: normal;
  text-align: left;
  max-height: 80vh;

  .pop-title {
    margin: 0 30px;
    height: 60px;
    padding-top: 20px;
    display: flex;
    align-items: center;
    // justify-content: center;
    text-align: left;
    position: relative;
    // border-bottom: 2px solid #e8e8e8;

    .title {
      font-family: $fontFamily;
      font-size: 18px;
      line-height: 20px;
      // color: #1e4380;
      font-weight: 600;
    }

    .icon {
      font-size: 22px;
      color: #bbbbbb;
      position: absolute;
      left: 0px;
    }

    .shopping {
      color: #bbbbbb;
      position: absolute;
      right: 0px;
    }

    .van-badge__wrapper {
      display: flex;
    }

    /deep/.van-badge--fixed {
      top: 5px;
    }

    /deep/.van-badge {
      font-family: $fontFamily;
    }
  }

  .pop-title3 {
    margin: 0 20px;
    padding-bottom: 10px;
    height: 70px;
    display: flex;
    align-items: end;
    position: relative;
    border-bottom: 2px solid #e8e8e8;

    .title {
      font-family: $fontFamily;
      font-size: 20px;
      line-height: 22px;
      color: #1e4380;
      font-weight: 600;
    }
  }

  .pop-title2 {
    margin: 0 20px;
    padding-bottom: 10px;
    height: 70px;
    display: flex;
    align-items: end;
    justify-content: center;
    position: relative;
    border-bottom: 2px solid #e8e8e8;

    .title {
      font-family: $fontFamily;
      font-size: 20px;
      line-height: 22px;
      color: #1e4380;
      font-weight: 600;
    }
  }

  .pop-container {
    // padding: 0 30px;
    max-height: calc(80vh - 160px);
    overflow-y: auto;
    .pop-item-active {
      background: #fbfafa;
    }
    .pop-item {
      min-height: 50px;
      padding: 10px 30px;
      // border-top: 1px solid #e8e8e8;
      display: flex;
      align-items: center;
      // justify-content: center;
      text-align: left;
      .active {
        color: #2b5dad !important;
      }
      img {
        height: 22px;
        margin-right: 25px;
      }
      .text {
        color: #000000;
        font-size: 15px;
        line-height: 17px;
        font-family: $fontFamily;
        width: 80px;
      }
      .text2 {
        flex: 0.9;
        color: #555;
        font-size: 13px;
        line-height: 17px;
        font-family: $fontFamily;
      }
      .text3 {
        font-size: 20px;
        line-height: 17px;
        font-family: $fontFamily;
      }
      .icon {
        font-size: 18px;
        color: #bbbbbb;
      }

      &:first-child {
        border-top: 0px;
      }
    }

    .other-select {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;
      padding-left: 50px;

      .select-other {
        flex: 1;
        font-size: 15px;
        font-family: $fontFamily;
      }

      /deep/.ant-select-selection {
        border-color: transparent;
        background-color: #f3f3f3;
        border-radius: 6px;
        box-shadow: none !important;
      }
      /deep/.ant-select-selection__placeholder {
        color: #9a9a9a;
      }
      /deep/.ant-select-selection:hover {
        border-color: transparent;
        box-shadow: 0 0 0 1px #9a94c0 !important;
      }
    }

    .van-stepper {
      display: flex;
      flex-flow: nowrap;
      align-items: center;
      justify-content: center;
      margin-left: 20px;
    }

    /deep/.van-stepper--round .van-stepper__minus {
      background-color: #ffffff;
      color: #4f4f4f;
      border: 2px solid #4f4f4f;
    }

    /deep/.van-stepper--round .van-stepper__plus {
      background-color: #ffffff;
      color: #4f4f4f;
      border: 2px solid #4f4f4f;
    }

    /deep/.van-stepper__minus::before,
    /deep/.van-stepper__plus::before {
      height: 2px !important;
    }

    /deep/.van-stepper__minus::after,
    /deep/.van-stepper__plus::after {
      width: 2px !important;
    }

    /deep/.van-stepper--round .van-stepper__input {
      font-family: $fontFamily;
      font-size: 16px;
      // line-height: 22px;
      height: 24px !important;
      font-weight: 600;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .btn-area {
    height: 100px;
    border-top: 2px solid #e8e8e8;
    display: flex;
    align-items: center;
    justify-content: center;

    .btn {
      height: 47px;
      width: 167px;
      border-radius: 20px;
      background-color: $primary-color;
      display: flex;
      align-items: center;
      justify-content: center;

      span {
        font-size: 16px;
        line-height: 18px;
        font-family: $fontFamily;
        color: #ffffff;
      }
    }
  }

  .pop-info {
    padding: 0 40px;
    .text {
      font-size: 15px;
      line-height: 19px;
      color: #000000;
      font-family: $fontFamily;
      margin-bottom: 10px;
    }

    .info-item {
      padding-left: 20px;
      font-size: 15px;
      line-height: 20px;
      color: #000000;
      font-family: $fontFamily;
      position: relative;

      &:before {
        position: absolute;
        content: "";
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background-color: $primary-color;
        left: 0px;
        top: 7px;
      }
    }

    .info-item:last-child {
      margin-bottom: 20px;
    }

    /deep/.van-radio__label {
      font-size: 15px;
      line-height: 17px;
      color: #333333;
      font-family: $fontFamily;
    }

    /deep/.van-radio__icon--checked .van-icon {
      background-color: $primary-color;
      border-color: $primary-color;
    }
  }
}
/deep/.van-overlay {
  background-color: rgba(0, 0, 0, 0.4);
}
.van-popup--bottom.van-popup--round {
  border-radius: 12px 12px 0 0;
}

.van-popup--center.van-popup--round {
  border-radius: 6px;
}

// 修改字间距
// .fontPadding {
//   letter-spacing: -1px;
// }

/deep/.chose-language {
  .van-icon__image {
    width: 18px;
    height: 18px;
    margin: 9px;
  }
}
</style>
